export const stakeRoutes = [
    {
        name: "stake-list",
        path: "/stakes",
        component: () => import("@/app/stakes/StakeList"),
        props: true
    },
    {
        name: "stake-add",
        path: "/stakes/new",
        component: () => import("@/app/stakes/StakeEdit"),
        props: true
    },    
    {
        name: "stake-detail",
        path: "/stake/:stakeId/ward-list",
        component: () => import("@/app/stakes/StakeDetail"),
        props: true
    },
    {
        name: "ward-create",
        path: "/stake/:stakeId/create-ward",
        component: () => import("@/app/wards/Ward"),
        props:true
    },
    {
        name: "stake-edit",
        path: "/stake/:stakeId/modify-stake",
        component: () => import("@/app/stakes/StakeEdit"),
        props: true
    }
]
